import React from "react"
import PropTypes from "prop-types"

const OnSymbol = props => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        fontSize: 12,
        color: "#fff",
        paddingRight: 2,
      }}
    >
      {" "}
      {props?.text || ""}
    </div>
  )
}
export default OnSymbol
OnSymbol.propTypes = {
  text: PropTypes.string,
}
